import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

import NProgress from "nprogress";
import "../../../node_modules/nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });

import DefaultLayout from "../vue/layout/DefaultLayout.vue";
import TheMainPage from "../vue/pages/mainpage/TheMainPage.vue";

// lazy loading components
const TheProductDetails = () =>
    import("../vue/pages/product/TheProductDetails.vue");
const TheAboutUs = () => import("../vue/pages/TheAboutUs.vue");
const The404 = () => import("../vue/pages/The404.vue");
const TheSearch = () => import("../vue/pages/search/TheSearch.vue");
const TheProfile = () => import("../vue/pages/user/TheProfile.vue");
const TheLogin = () => import("../vue/pages/auth/TheLogin.vue");
const TheShopCart = () => import("../vue/pages/shopcart/TheShopCartPage.vue");
const TheHelp = () => import("../vue/pages/TheHelp.vue");
const TheFaq = () => import("../vue/pages/TheFaq.vue");
const TheContacts = () => import("../vue/pages/TheContacts.vue");
const TheOferta = () => import("../vue/pages/TheOferta.vue");
const TheDelivery = () => import("../vue/pages/delivery/TheDelivery.vue");
const TheProductAll = () => import("../vue/pages/product/TheProductAll.vue");
const TheFavorite = () => import("../vue/pages/favorite/TheFavorite.vue");
const ForSuppliers = () => import("../vue/pages/ForSuppliers.vue");
const Redirect = () => import("../vue/pages/redirects/Redirect.vue");
const AllBrands = () => import("../vue/pages/brands/AllBrands.vue");
const TheCompany = () => import("../vue/pages/company/TheCompany.vue");

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",

    routes: [
        {
            path: "",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "home",
                    component: TheMainPage
                },

                {
                    path: "cl/aboutus",
                    name: "aboutus",
                    component: TheAboutUs
                },

                {
                    path: "cl/404",
                    name: "404",
                    component: The404
                },

                {
                    path: "cl/category/:id",
                    name: "category",
                    component: TheSearch
                },

                {
                    path: "cl/search/:id",
                    name: "search",
                    component: TheSearch
                },

                {
                    path: "cl/allproducts/:id",
                    name: "allproducts",
                    component: TheSearch
                },

                {
                    path: "cl/brands/:id",
                    name: "brands",
                    component: TheSearch
                },

                {
                    path: "cl/shop/:id",
                    name: "shop",
                    component: TheSearch
                },

                {
                    path: "cl/profile",
                    name: "profile",
                    component: TheProfile
                },

                {
                    path: "cl/login",
                    name: "login",
                    component: TheLogin
                },

                {
                    path: "cl/shopcart",
                    name: "shopcart",
                    component: TheShopCart
                },

                {
                    path: "cl/help",
                    name: "help",
                    component: TheHelp
                },

                {
                    path: "cl/help/:id",
                    name: "helpSecond",
                    component: TheHelp
                },

                {
                    path: "cl/faq",
                    name: "faq",
                    component: TheFaq
                },

                {
                    path: "cl/oferta",
                    name: "oferta",
                    component: TheOferta
                },

                {
                    path: "cl/contacts",
                    name: "contacts",
                    component: TheContacts
                },

                {
                    path: "cl/delivery",
                    name: "delivery",
                    component: TheDelivery
                },

                {
                    path: "cl/product/:id/:slug?",
                    name: "product",
                    component: TheProductDetails
                },

                {
                    path: "cl/productall/:id",
                    name: "productall",
                    component: TheProductAll
                },

                {
                    path: "cl/favorite",
                    name: "favorite",
                    component: TheFavorite
                },

                {
                    path: "cl/forsuppliers",
                    name: "forsuppliers",
                    component: ForSuppliers
                },

                {
                    path: "cl/redirect",
                    name: "redirect",
                    component: Redirect
                },

                {
                    path: "cl/allbrands",
                    name: "allbrands",
                    component: AllBrands
                },

                {
                    path: "cl/company/:id",
                    name: "company",
                    component: TheCompany
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.name) {
        NProgress.start();
    }
    store.dispatch("CANCEL_PENDING_REQUESTS");
    next();
});

router.afterEach((to, from) => {
    NProgress.done();
    window.scrollTo(0, 0);
});

export default router;
